import { HttpMethod } from "@/types/https";
import {
  EditableColumnProperties,
  EditableColumnsResponse,
} from "../types/editable-columns.type";
import { ENDPOINT } from "../endpoint";
import { apiCall } from "../base";

export const GetEditableColumns = () => {
  return {
    name: `GetEditableColumns`,
    handle: (): Promise<EditableColumnsResponse> =>
      apiCall<EditableColumnsResponse>({
        url: ENDPOINT.EDITABLE_COLUMNS,
        method: HttpMethod.GET,
      }),
  };
};

export const UpdateEditableColumns = () => {
  return {
    name: `UpdateEditableColumns`,
    handle: (
      data: EditableColumnProperties[],
    ): Promise<EditableColumnsResponse> =>
      apiCall<EditableColumnsResponse>({
        url: ENDPOINT.EDITABLE_COLUMNS,
        method: HttpMethod.PUT,
        body: data,
      }),
  };
};
